import { CreateEscortComponent } from './create-escort/create-escort.component';
import { EditEscortComponent } from './edit-escort/edit-escort.component';
import { SingleViewEscortComponent } from './view-escort/single-view-escort.component';
import { ViewEscortComponent } from './view-escort/viewescort.component';

export const EscortDetailsDeclatation = [
    CreateEscortComponent,
    ViewEscortComponent,
    SingleViewEscortComponent,
EditEscortComponent
];
